import React, { useState, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';

import AsyncGenericSelect from '../../../components/ui/AsyncGenericSelect';
import TextInput from '../../../components/ui/TextInput.jsx';
import Button from '../../../components/ui/Button';
import { buildSelfExcludedEmployeeAsync } from '../config';

// Faz D (spec 2026-08-08 §4, Task 5) — "Geri Bildirim İste" modalı.
// one-on-ones/components/NewMeetingModal.js ile BİREBİR AYNI Overlay/Modal/
// Header/Footer iskeleti (repo genelinde tekrarlanan modal deseni, desen
// aynası). POST v1/feedback-requests body { targetEmployeeId, message? }
// (task-2-report.md §1) — kendine talep reddi (selfRequest) ve mükerrer
// pending reddi (duplicatePending) BURADA YAKALANMAZ, başarısız yanıtta
// modal AÇIK kalır (kullanıcı başka bir çalışan seçip tekrar dener), gerçek
// hata mesajı Axios interceptor'ın standart toast'ıyla gösterilir —
// NewMeetingModal'ın notDirectManager deseniyle AYNI disiplin.
const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 42, 42, 0.4);
  backdrop-filter: blur(2px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 6px;
  width: 480px;
  max-width: 92vw;
  max-height: 88vh;
  overflow-y: auto;
  padding: 28px;
  box-shadow: 0 16px 48px rgba(0, 66, 66, 0.15);
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;

const Title = styled.h3`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.text.primary};
`;

const CloseBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  cursor: pointer;
  padding: 6px;
  border-radius: 4px;
  color: #A0A8B4;
  &:hover:not(:disabled) { background: #F1F5F9; color: #004242; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

const Field = styled.div`
  margin-bottom: 16px;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 8px;
`;

export default function RequestFeedbackModal({ excludeEmployeeId, onClose, onCreate }) {
  const { t } = useTranslation();

  const [targetEmployeeId, setTargetEmployeeId] = useState(null);
  const [message, setMessage] = useState('');
  const [saving, setSaving] = useState(false);

  const targetAsync = useMemo(
    () => buildSelfExcludedEmployeeAsync(excludeEmployeeId),
    [excludeEmployeeId],
  );

  const valid = !!targetEmployeeId;

  const handleSubmit = useCallback(async () => {
    setSaving(true);
    const created = await onCreate({
      targetEmployeeId,
      message: message.trim() ? message.trim() : undefined,
    });
    if (created) {
      onClose();
      return;
    }
    setSaving(false);
  }, [onCreate, onClose, targetEmployeeId, message]);

  return (
    <Overlay onClick={saving ? undefined : onClose}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>{t('feedbackRequests.modal.title')}</Title>
          <CloseBtn onClick={onClose} disabled={saving}><X size={18} /></CloseBtn>
        </Header>

        <Field>
          <AsyncGenericSelect
            label={t('feedbackRequests.modal.employeeLabel')}
            value={targetEmployeeId}
            onChange={setTargetEmployeeId}
            onSearch={targetAsync.onSearch}
            onGetById={targetAsync.onGetById}
            required
          />
        </Field>

        <Field>
          <TextInput
            label={t('feedbackRequests.modal.messageLabel')}
            type="textarea"
            rows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </Field>

        <Footer>
          <Button variant="outline" onClick={onClose} disabled={saving}>
            {t('common.cancel')}
          </Button>
          <Button data-role="create-request-btn" onClick={handleSubmit} disabled={!valid || saving}>
            {saving ? t('common.saving') : t('common.save')}
          </Button>
        </Footer>
      </Modal>
    </Overlay>
  );
}
